import type { OptionKV } from "~styled/selector/Selector";

export enum ETipoEndoso {
  Anulacion = "Anulacion",
  CambioFormaPago = "CambioFormaPago",
  DatosIncorrectos = "DatosIncorrectos",
}

export enum EMotivoAnulacion {
  VentaUnidad = "VentaUnidad",
  CambioCompania = "CambioCompania",
  MalServicio = "MalServicio",
  NoEspecifica = "NoEspecifica",
}

export enum EEstadoEndoso {
  Rechazado = "Rechazado",
  Pendiente = "Pendiente",
  Aplicado = "Aplicado",
}

export const ANULACION = ETipoEndoso.Anulacion;
export const FORMA_PAGO = ETipoEndoso.CambioFormaPago;
export const DATOS = ETipoEndoso.DatosIncorrectos;
export const TODOS = "Todos";

const tipoEndosoOptions: Record<ETipoEndoso, string> = {
  [ANULACION]: "Anulación",
  [FORMA_PAGO]: "Cambio forma de pago",
  [DATOS]: "Correción de datos",
};

// El valor llega crudo del backend, así que puede no ser uno de los tipos
// conocidos: en ese caso no hay etiqueta.
export const getTipoEndosoLabel = (
  tipo: string | null | undefined
): string | undefined =>
  (tipoEndosoOptions as Record<string, string>)[String(tipo)];

const tipoEndosoFilter: OptionKV<ETipoEndoso>[] = [
  { label: tipoEndosoOptions[ANULACION], value: ANULACION },
  { label: tipoEndosoOptions[FORMA_PAGO], value: FORMA_PAGO },
  { label: tipoEndosoOptions[DATOS], value: DATOS },
];

export const VENTA_UNIDAD = EMotivoAnulacion.VentaUnidad;
export const CAMBIO_COMPANIA = EMotivoAnulacion.CambioCompania;
export const MAL_SERVICIO = EMotivoAnulacion.MalServicio;
export const NO_ESPECIFICA = EMotivoAnulacion.NoEspecifica;

const motivoAnulacionFilter: OptionKV<EMotivoAnulacion>[] = [
  { label: "Venta de unidad", value: VENTA_UNIDAD },
  { label: "Cambio de compañia", value: CAMBIO_COMPANIA },
  { label: "Mal servicio", value: MAL_SERVICIO },
  { label: "No especifica", value: NO_ESPECIFICA },
];

// Las claves `null`, `true` y `false` son las que resultan de indexar estos
// mapas con el valor crudo del campo: al usarlo como clave se convierte a texto.
const motivoAnulacionOptions: Record<EMotivoAnulacion | "null", string> = {
  null: "Selecciona un motivo",
  [VENTA_UNIDAD]: "Venta de unidad",
  [CAMBIO_COMPANIA]: "Cambio de compañia",
  [MAL_SERVICIO]: "Mal servicio",
  [NO_ESPECIFICA]: "No especifica",
};

// Igual que con el tipo de endoso: un motivo desconocido no tiene etiqueta.
export const getMotivoAnulacionLabel = (
  motivo: string | null | undefined
): string | undefined =>
  (motivoAnulacionOptions as Record<string, string>)[String(motivo)];

const tieneGNCFilter: OptionKV<boolean | null>[] = [
  { label: "SI", value: true },
  { label: "NO", value: false },
  { label: "No Informado", value: null },
];

const tieneGNCOptions: Record<"true" | "false" | "null", string> = {
  true: "SI",
  false: "NO",
  null: "No Informado",
};

export const RECHAZADO = EEstadoEndoso.Rechazado;
export const PENDIENTE = EEstadoEndoso.Pendiente;
export const APLICADO = EEstadoEndoso.Aplicado;

const estadoEndosoOptions: Record<EEstadoEndoso | "null", string> = {
  [RECHAZADO]: RECHAZADO,
  [PENDIENTE]: PENDIENTE,
  [APLICADO]: APLICADO,
  null: "Todos",
};

const estadoEndosoFilter: OptionKV<EEstadoEndoso | null>[] = [
  { label: TODOS, value: null },
  { label: PENDIENTE, value: PENDIENTE },
  { label: APLICADO, value: APLICADO },
  { label: RECHAZADO, value: RECHAZADO },
];

export {
  tipoEndosoOptions,
  tipoEndosoFilter,
  motivoAnulacionFilter,
  motivoAnulacionOptions,
  tieneGNCFilter,
  tieneGNCOptions,
  estadoEndosoOptions,
  estadoEndosoFilter,
};
